export default __webpack_public_path__ + "static/media/macs-gmp2.70be49e0.jpg";